import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import {
  Select,
  MenuItem,
} from '@material-ui/core'

import * as TimeseriesActionCreators from '../../actions/timeseries'

class TimeseriesTypesSelectContainer extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    sensorType: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    timeseriesActions: PropTypes.object.isRequired,
    timeseriesTypes: PropTypes.object.isRequired,
  }

  static defaultProps = {
    value: null,
    sensorType: null,
  }

  static mapStateToProps(state) {
    return {
      timeseriesTypes: state.timeseriesTypes,
    }
  }

  static mapDispatchToProps(dispatch) {
    return {
      timeseriesActions: bindActionCreators(TimeseriesActionCreators, dispatch),
    }
  }

  componentDidMount() {
    this.props.timeseriesActions.listTimeseriesTypes()
  }

  onChange = (e) => {
    this.props.onChange(e.target.value)
  }

  render() {
    const {
      value, sensorType, onChange,
      timeseriesActions, timeseriesTypes,
      ...props
    } = this.props

    let tsTypes = Object.entries(timeseriesTypes)
    if (sensorType) {
      tsTypes = tsTypes.filter(([, v]) => (v.type === sensorType))
    }

    // Sort by title
    tsTypes.sort((a, b) => a[1].title.localeCompare(b[1].title))
    return (
      <Select value={value} onChange={this.onChange} {...props}>
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        {tsTypes.map(([k, v]) => (
          <MenuItem key={k} value={k}>
            {v.title}
          </MenuItem>
        ))}
      </Select>
    )
  }
}

export default connect(
  TimeseriesTypesSelectContainer.mapStateToProps,
  TimeseriesTypesSelectContainer.mapDispatchToProps,
)(TimeseriesTypesSelectContainer)
